import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { titleCase } from "title-case";

interface FancyHoverComponentProps {
  title?: string;
  data: string | Array<string>;
  horizontalAlign?: "left" | "right";
  children: React.ReactNode;
}

const FancyHoverComponent: React.FC<FancyHoverComponentProps> = ({
  title,
  data,
  horizontalAlign = "left",
  children,
}) => {
  const content = (
    <>
      {title && <Typography variant="subtitle2">{title}</Typography>}
      {Array.isArray(data) ? (
        <Box
          component="ul"
          sx={{
            margin: 0,
            paddingInlineStart: "var(--space-6)",
            maxHeight: "128px",
            overflowY: "auto",
          }}
        >
          {data.map(
            (item, idx) =>
              item && (
                <Typography key={idx} component="li" variant="body2" noWrap>
                  {titleCase(item.toLowerCase())}
                </Typography>
              ),
          )}
        </Box>
      ) : (
        <Typography variant="body2">{data}</Typography>
      )}
    </>
  );

  return (
    <Tooltip
      title={content}
      placement={horizontalAlign === "left" ? "bottom-start" : "bottom-end"}
      slotProps={{ tooltip: { sx: { maxWidth: "320px" } } }}
    >
      <Box>{children}</Box>
    </Tooltip>
  );
};

export default FancyHoverComponent;
